"use client";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useParams, usePathname } from "next/navigation";
import Link from "@/components/core/localized-mui-link";
import { localizePath, resolveCurrentLocale } from "@/utils/localize-path";

const Banner: React.FC<{
  subTitle: string;
  title: string;
  paragraph: string;
  buttonText: string;
  buttonLink: string;
  rightPadding: string;
  marginBottom?: string;
  target?: string;
  children: React.ReactNode;
}> = ({
  subTitle,
  title,
  paragraph,
  buttonText,
  buttonLink,
  rightPadding,
  marginBottom,
  target = "_self",
  children,
}) => {
  const params = useParams();
  const pathname = usePathname();
  const localizedButtonLink = localizePath(
    buttonLink,
    resolveCurrentLocale(params?.lang, pathname),
  );

  return (
    <Box
      sx={{
        maxHeight: {
          xs: "none",
          md: "520px",
        },
        display: "flex",
        flexDirection: {
          xs: "column-reverse",
          md: "row",
        },
        gap: "35px",
        marginTop: "35px",
        marginBottom,
        backgroundColor: "#e9eafb",
        borderRadius: "25px",
      }}
    >
      {children}
      <Box
        sx={{
          flexBasis: "50%",
          padding: {
            xs: "40px 25px 0 25px",
            sm: "50px 25px 15px 25px",
            md: "50px 30px 50px 60px",
            lg: rightPadding,
          },
        }}
      >
        <Typography
          color="#4b00ff"
          sx={{ opacity: "0.8", marginBottom: "10px", fontSize: { xs: "13px", md: "16px" } }}
        >
          {subTitle}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "32px", sm: "30px", lg: "40px" },
            fontWeight: "bold",
            marginBottom: { xs: "15px", md: "20px" },
            lineHeight: "1.15",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{ fontSize: { xs: "16px", md: "18px" }, marginBottom: "10px", lineHeight: "1.44" }}
        >
          {paragraph}
        </Typography>
        <Button
          data-testid={`banner-${title.toLowerCase().replace(" ", "-").replace(/\s/g, "")}-btn`}
          color="primary"
          variant="contained"
          component={Link}
          href={localizedButtonLink}
          target={target}
          sx={{
            marginTop: "30px",
            width: { xs: "100%", md: "unset" },
            fontSize: "17px !important",
          }}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default Banner;
